<template>
  <div id="app" style="min-width: 490px;">
    <!-- <popup-pwa/> -->
    <router-view></router-view>
  </div>
</template>

<script>
import PopupPwa from './components/dash/PopupPwa.vue'
import { version } from "./../package.json"
export default {
  name: 'app',

  components: {
    PopupPwa
  },
  
  created() {
    window.$crisp.push(["set", "session:data", ["front_version", version]]);
  }
}
</script>

<style src="./assets/scss/style.scss" lang="scss"></style>